type EditorType =
  | 'text'
  | 'date'
  | 'entity-search'
  | 'select'
  | 'status'
  | 'boolean'
  | 'multi-select';

interface BulkEditorCapabilities {
  renderTextInput: boolean;
  renderDateInput: boolean;
  renderEntitySearch: boolean;
  isOptionList: boolean;
  needsManualSubmit: boolean;
}

const DEFAULT_EDITOR_CAPABILITIES: BulkEditorCapabilities = {
  renderTextInput: false,
  renderDateInput: false,
  renderEntitySearch: false,
  isOptionList: false,
  needsManualSubmit: false,
};

const EDITOR_CAPABILITIES_BY_TYPE: Record<EditorType, BulkEditorCapabilities> = {
  text: {
    renderTextInput: true,
    renderDateInput: false,
    renderEntitySearch: false,
    isOptionList: false,
    needsManualSubmit: true,
  },
  date: {
    renderTextInput: false,
    renderDateInput: true,
    renderEntitySearch: false,
    isOptionList: false,
    needsManualSubmit: true,
  },
  'entity-search': {
    renderTextInput: false,
    renderDateInput: false,
    renderEntitySearch: true,
    isOptionList: false,
    needsManualSubmit: true,
  },
  select: {
    renderTextInput: false,
    renderDateInput: false,
    renderEntitySearch: false,
    isOptionList: true,
    needsManualSubmit: false,
  },
  status: {
    renderTextInput: false,
    renderDateInput: false,
    renderEntitySearch: false,
    isOptionList: true,
    needsManualSubmit: false,
  },
  boolean: {
    renderTextInput: false,
    renderDateInput: false,
    renderEntitySearch: false,
    isOptionList: true,
    needsManualSubmit: false,
  },
  'multi-select': {
    renderTextInput: false,
    renderDateInput: false,
    renderEntitySearch: false,
    isOptionList: true,
    needsManualSubmit: true,
  },
};

export function getBulkEditorCapabilities(
  editorType: string | undefined,
): BulkEditorCapabilities {
  if (!editorType) {
    return DEFAULT_EDITOR_CAPABILITIES;
  }

  return EDITOR_CAPABILITIES_BY_TYPE[editorType as EditorType] ?? DEFAULT_EDITOR_CAPABILITIES;
}
